import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=5bba1b7b&scoped=true&"
import script from "./Update.vue?vue&type=script&lang=js&"
export * from "./Update.vue?vue&type=script&lang=js&"
import style0 from "./Update.vue?vue&type=style&index=0&id=5bba1b7b&scoped=true&lang=css&"
import style1 from "./Update.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bba1b7b",
  null
  
)

export default component.exports